/**
 * DevExtreme (esm/ui/load_indicator.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import LoadIndicator from "../__internal/ui/m_load_indicator";
export default LoadIndicator;
